import { FC } from "react";
import { FaArrowRight } from "react-icons/fa";
import { BannerData } from "../../models/types";
import { useNavigate } from "react-router-dom";

type Props = {
  bannerData: BannerData;
  home?: boolean; // Optional prop to handle different styles for home page,
  contact?: boolean; // Optional prop to handle different styles for contact page
  resourcePassData?: boolean;
};

const ServicesBanner: FC<Props> = ({ bannerData, home, contact, resourcePassData }) => {
  const navigate = useNavigate();
  const toAuth = () => {
    if (resourcePassData) {
      navigate("/contact-us");
    } else {
      navigate("/dashboard");
    }
  };
  return (
    <div className={`container  mx-auto  ${home ? "mt-[230px] mb-[50px] md:mt-[300px] lg:mt-[200px] md:mb-[120px] xl:mt-[250px]" : contact ? "mt-[120px] mb-[50px] md:mt-[150px] lg:mt-[80px] md:mb-[70px] xl:my-[150px]" : "mt-[230px] mb-[50px] md:mt-[300px] lg:mt-[250px] md:mb-[120px] xl:mt-[280px]"} flex w-[90%] items-center bg-ideasSectionBg bg-cover rounded-2xl bg-no-repeat 
 sm:max-w-xl md:max-w-[700px] lg:max-h-[350px] lg:max-w-4xl xl:max-w-6xl 2xl:max-w-7xl`}>
      <div className="flex  h-full w-full flex-col items-center lg:flex-row">
        <div className="flex w-full justify-center lg:w-1/2">
          <img
            src={bannerData.img}
            className="max-h-[300px] object-cover sm:max-h-[350px] md:max-h-[500px] lg:max-h-[550px] -mt-28 sm:-mt-36 md:-mt-48 lg:-mt-[270px] "
            alt="Banner"
          />
        </div>

        <div className="flex w-full flex-col items-center  p-4 text-white sm:p-6 md:p-8 lg:w-1/2 lg:items-start">

          {/* props pass for resouces page section to pass extra fields */}

          {resourcePassData && <h6 className="text-sm font-medium text-center lg:text-left break-words">
            {bannerData.smHeading}
          </h6>}

          <h1 className="md:mb-4 mb-3 font-heading mt-2 text-center lg:text-left text-2xl sm:text-3xl md:text-[36px]  2xl:text-[52px] leading-snug sm:leading-normal md:leading-[3rem] lg:leading-[3.25rem] break-words">
            {bannerData.lgHeading}
          </h1>

          {bannerData.isheadLine && (
            <p className="2xl:mb-6 mb-3 mt-2 font-sfPro text-center lg:text-left lg:text-xl md:text-[17px] sm:text-sm text-xs">
              {bannerData.paragraph}
            </p>
          )}

          {resourcePassData && (
            <p className=" font-sfPro  text-sm t">
              {bannerData.details}
            </p>
          )}

          {resourcePassData && (
            <div>
              <p className=" font-sfPro pt-1 text-sm">
                <span className="font-bold">Support Email & Phone Number : </span>
                {bannerData.supportTitle}
              </p>
              <p className=" font-sfPro  text-sm">
                <span className="font-bold">Need help right away? : </span>
                {bannerData.helpText}
              </p>
            </div>
          )}


          <div className="my-4 flex justify-center sm:mt-6 lg:justify-start">
            <button
              onClick={toAuth}
              className="flex items-center justify-center font-sfPro gap-2 rounded-full bg-white px-6 py-3 text-sm font-medium text-black transition-all duration-300 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-50 sm:px-8 sm:py-3.5 sm:text-base"
            >
              {bannerData.btnText} <FaArrowRight />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesBanner;

